import {Service} from "../Service";

export class MotorService extends Service{
    constructor() {
        super('motor/');
    }



    obtenerSiguenteFlujo(params) {
        return this.http.post(this.getUrl(['flujo', 'siguiente']), params)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTickets(idEmpleado, filtro) {
        return this.http.post(this.getUrl(['obtener', 'tickets'],{idEmpleado:idEmpleado}),filtro)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerMovimientos(params) {
        return this.http.post(this.getUrl(['obtener', 'moviminetos']), params)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerEtapasPorClasificacion(params) {
        return this.http.post(this.getUrl(['etapas', 'clasificacion']), params)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarMovimiento(body) {
        return this.http.post(this.getUrl(['guardar', 'moviminetos']),body)
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerEstatusSolicitudEtapa(params) {
        return this.http.post(this.getUrl(['obtener','estatus','solicitud-etapa']), params)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
